/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskIssuetypesRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIssuetypesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import IssueTypePage, { LazyIssueTypeSettings } from './ui/issue-type/index.tsx';
import { getUFOName } from './common/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskIssuetypesRouteEntry: Route = createEntry(
	projectSettingsServicedeskIssuetypesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: getUFOName('project-settings-servicedesk-issuetypes'),
		// eslint-disable-next-line no-restricted-syntax
		component: IssueTypePage,
		layout: serviceProjectLayout,

		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
